import { Config } from "core/models/Config";

declare global {
    interface Window {
        jsonConfig: Config;
    }
}

class Configuration {
    static get(key: keyof Config): string {
        const config = window.jsonConfig;
        return config[key];
    }

    static set(key: keyof Config, value: string): void {
        const config = window.jsonConfig;
        config[key] = value;
    }
}

export default Configuration;
